module.exports = __webpack_public_path__ + "img/AGI.69521cf3.svg";